import Image from 'next/image';
import { CTA } from 'react-scale/components';

import s from './blurb.module.css';

const Blurb = ({
  icon,
  title,
  subtitle,
  cta = {
    hubspotModal: {
      formId: '93b06c19-5aea-4e56-b832-e2c6bfec9c17',
      sfdcCampaignId: '7015G000001VA6IQAW',
      label: 'Schedule a Demo'
    }
  }
}) => (
  <div className="flex flex-col -left-6 sm:left-0 relative xl:flex-row space-y-3 sm:space-y-0 bg-gray-900 px-7 xl:pr-[132px] xl:pl-40 py-8 sm:py-12 sm:rounded-xl w-screen sm:w-full">
    <div>
      <div className="lg:!hidden xl:px-2 pb-5">
        <Image width={66} height={74} alt={icon.alt} src={icon.url} layout="fixed" />
      </div>
      <div className="hidden lg:block">
        <Image width={83} height={98} src={icon.url} alt={icon.alt} layout="fixed" />
      </div>
    </div>
    <div className="flex-1 xl:py-0 xl:ml-[72px]">
      <p className="text-lg sm:text-xl xl:text-2xl leading-8 xl:leading-9 font-aeonik text-white">
        {title}
      </p>
      <p className="md:text-white leading-[30px] md:leading-8 pr-[14px] sm:pr-0 text-gray-300 md:text-lg mt-6 xl:mt-4">
        {subtitle}
      </p>
      <div className={s.cta}>
        <CTA cta={cta} />
      </div>
    </div>
  </div>
);

export default Blurb;
